<header class="dialog-header">
	<div>
		<ng-content></ng-content>
	</div>
	<button [attr.title]="'close' | translate" [attr.aria-label]="'close' | translate" class="action" (click)="close()">
		<i class="ico ico-close"></i>
	</button>
</header>
<ng-content></ng-content>
